import {
  IWithWorksheetInjectedProps,
  WorksheetBalanceFieldSet,
  WorksheetEquipmentDropdown,
} from 'Components/Worksheets/Core';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import React from 'react';
import { useSelector } from 'react-redux';
import deepEquals from '../../../../../../Lib/Object/deepEquals';
import { Checkbox, Dropdown, Field, Label, NumericInput } from '../../../../../Core';
import { withInjectedProps } from '../../../../../Core/InjectedPropsContext';
import { FieldSet, ListFieldSection, SectionGroup } from '../../../../../Layout';
import { LiquidLimitSpecimen } from '../../types';
import AsLiquidLimitFourPointTrialSection from './LiquidLimitFourPointTrialSection';

export interface ILiquidLimitFourPointSection extends IWithWorksheetInjectedProps {
  hideLinearShrinkageFields?: boolean;
}

let AsLiquidLimitFourPointDeterminationSection: React.FC<ILiquidLimitFourPointSection> = ({
  createWorksheetSelector,
  hideLinearShrinkageFields = true,
}) => {
  const determinationPerformed = useSelector(
    pipe(createWorksheetSelector!('NonPlastic'), valueOrDefault(false), (np) => !np)
  );

  const trialRecordProps = useSelector(
    pipe(createWorksheetSelector!('Trials'), valueOrDefault([] as Array<LiquidLimitSpecimen>), (trials) =>
      trials
        .filter((t) => t.SuitableForShrinkage)
        .map((t) => {
          return { index: trials.indexOf(t) + 1, TrialId: t.TrialId };
        })
    ),
    deepEquals
  );

  return (
    <>
      <SectionGroup heading="Liquid Limit Determination">
        <ListFieldSection>
          <FieldSet>
            <Label>Material Suitability</Label>
            <Field input={<Checkbox />} label="Result cannot be obtained" name="NonPlastic" />
          </FieldSet>
        </ListFieldSection>
        {determinationPerformed && (
          <>
            <ListFieldSection>
              <WorksheetBalanceFieldSet label="Balance" name="Balance" />
            </ListFieldSection>
            <ListFieldSection>
              <Field input={<WorksheetEquipmentDropdown />} label="Oven" equipmentType="oven" name="Oven" />
              <Field input={<NumericInput />} name="DryingTemperature" />
              <WorksheetBalanceFieldSet label="Dry Mass Balance" name="DryMassBalance" />
            </ListFieldSection>
            <AsLiquidLimitFourPointTrialSection hideLinearShrinkageFields={hideLinearShrinkageFields} />
          </>
        )}
      </SectionGroup>
      <ListFieldSection visible={determinationPerformed}>
        <Field
          input={<Dropdown />}
          visible={!hideLinearShrinkageFields}
          name="SelectedTrialForShrinkage"
          simpleValue
          options={trialRecordProps.map((e) => ({ label: e.index.toString(), value: e.TrialId }))}
        />
      </ListFieldSection>
    </>
  );
};

AsLiquidLimitFourPointDeterminationSection = withInjectedProps(AsLiquidLimitFourPointDeterminationSection);

export { AsLiquidLimitFourPointDeterminationSection };
export default AsLiquidLimitFourPointDeterminationSection;
